var swiper = new Swiper(".charity-mission-swiper", {
  spaceBetween: 0,
  freeMode: true,
  slidesPerView: 1,
  breakpoints: {
    768: {
      slidesPerView: 3,
    },

  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});